import React from 'react';
import styled, { keyframes, css } from 'styled-components';

const Navigation = ({ activeSection, setActiveSection }) => {
  return (
    <NavContainer>
      <NavLinks>
        <NavLink
          active={activeSection === 'quotes'}
          onClick={() => setActiveSection('quotes')}
          gold
        >
          Stoic Quotes
        </NavLink>
        <NavLink
          active={activeSection === 'villain'}
          onClick={() => setActiveSection('villain')}
          red
        >
          Your Villain
        </NavLink>
        <NavLink
          active={activeSection === 'motivation'}
          onClick={() => setActiveSection('motivation')}
          blue
        >
          AI Motivation
        </NavLink>
      </NavLinks>
    </NavContainer>
  );
};

const pulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(212, 175, 55, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(212, 175, 55, 0);
  }
`;

const redPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(170, 51, 51, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(170, 51, 51, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(170, 51, 51, 0);
  }
`;

const bluePulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(70, 130, 180, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(70, 130, 180, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(70, 130, 180, 0);
  }
`;

const NavContainer = styled.nav`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem 0;
  margin-bottom: 1rem;
  border-bottom: 1px solid #222;
`;

const NavLinks = styled.div`
  display: flex;
  gap: 2rem;

  @media (max-width: 768px) {
    gap: 1rem;
  }
`;

const NavLink = styled.button`
  background: transparent;
  border: none;
  font-family: var(--font-primary);
  font-size: 1.2rem;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  color: ${props => {
    if (props.active) {
      if (props.red) return '#a33';
      if (props.blue) return '#4682b4';
      return '#d4af37';
    }
    return 'var(--color-secondary)';
  }};

  ${props => props.active && props.gold && css`
    animation: ${pulse} 2s infinite;
    text-shadow: 0 0 5px rgba(212, 175, 55, 0.5);
  `}

  ${props => props.active && props.red && css`
    animation: ${redPulse} 2s infinite;
    text-shadow: 0 0 8px rgba(170, 51, 51, 0.7);
  `}

  ${props => props.active && props.blue && css`
    animation: ${bluePulse} 2s infinite;
    text-shadow: 0 0 8px rgba(70, 130, 180, 0.7);
  `}

  &::after {
    content: '';
    position: absolute;
    bottom: -3px;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${props => {
      if (props.active) {
        if (props.red) return '#a33';
        if (props.blue) return '#4682b4';
        return '#d4af37';
      }
      return 'transparent';
    }};
    transform: scaleX(${props => props.active ? 1 : 0});
    transform-origin: center;
    transition: transform 0.3s ease;
  }

  &:hover {
    color: ${props => {
      if (props.red) return '#a33';
      if (props.blue) return '#4682b4';
      return '#d4af37';
    }};

    &::after {
      transform: scaleX(1);
      background: ${props => {
        if (props.red) return '#a33';
        if (props.blue) return '#4682b4';
        return '#d4af37';
      }};
    }
  }

  &:focus {
    outline: none;
  }
`;

export default Navigation;
